/**
 * People — bucket layout (DC-1645; grew out of the DC-1648 TeamLayout).
 *
 * The People rail destination: org modeling — who's in the organization and
 * what role they play in the assessment. Three tabs:
 * - Members (TeamManagement — the team roster)
 * - FAIR Personas (FairPersonasAdmin — catalog + topology toggle, DC-1648)
 * - Interviews (OrganizationalInterviews — moved from Governance, DC-1645)
 *
 * Renders standalone under the One Compass shell (extracted from the Settings
 * chrome). The `settings-page` wrapper is kept so leaf views keep resolving
 * the light-theme variable scope settings.css pins (DC-1602 lesson). Mirrors
 * the GovernanceLayout sub-nav pattern and reuses its token-clean stylesheet.
 */

import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Users, UserSquare2, MessagesSquare } from 'lucide-react';
import './governance-layout.css';

export const TeamLayout: React.FC = () => {
  return (
    <div className="settings-page">
      <header className="bucket-header">
        <h1>People</h1>
        <p className="bucket-subtitle">
          Who&rsquo;s in the organization and what role they play in the assessment — members,
          FAIR personas, and stakeholder interviews.
        </p>
      </header>

      <div className="governance-layout">
        <nav className="governance-subnav" role="navigation" aria-label="People navigation">
          <NavLink
            to="/settings/team"
            end
            className={({ isActive }) => `governance-tab ${isActive ? 'active' : ''}`}
          >
            <Users className="tab-icon" size={16} aria-hidden="true" />
            <span className="tab-label">Members</span>
          </NavLink>
          <NavLink
            to="/settings/team/personas"
            className={({ isActive }) => `governance-tab ${isActive ? 'active' : ''}`}
          >
            <UserSquare2 className="tab-icon" size={16} aria-hidden="true" />
            <span className="tab-label">FAIR Personas</span>
          </NavLink>
          <NavLink
            to="/settings/team/interviews"
            className={({ isActive }) => `governance-tab ${isActive ? 'active' : ''}`}
          >
            <MessagesSquare className="tab-icon" size={16} aria-hidden="true" />
            <span className="tab-label">Interviews</span>
          </NavLink>
        </nav>

        <div className="governance-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default TeamLayout;
